const thaiUnits = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];
const thaiScales = ['', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];

function numberToThaiWords(num) {
  if (num === 0) return thaiUnits[0];
  let result = '';
  let str = num.toString();
  for (let i = 0; i < str.length; i++) {
    const d = parseInt(str[i]);
    const pos = str.length - i - 1;
    if (d !== 0) {
      if (pos === 1 && d === 1) result += '';
      else if (pos === 1 && d === 2) result += 'ยี่';
      else if (pos === 0 && d === 1 && str.length > 1) result += 'เอ็ด';
      else result += thaiUnits[d];
      result += thaiScales[pos];
    }
  }
  return result;
}

export const convertToThai = (num) => {
  const intPart = Math.floor(Math.abs(num));
  const decPart = Math.round((Math.abs(num) - intPart) * 100);
  let res = numberToThaiWords(intPart);
  if (decPart > 0) res += 'จุด' + numberToThaiWords(decPart);
  return res;
};